require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./police-community-relations-in-albina.json") })
        }
      }, "path---police-community-relations-in-albina");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---police-community-relations-in-albina!./.cache/json/police-community-relations-in-albina.json
// module id = 951
// module chunks = 231608221292675